import { Col, Row } from 'react-bootstrap'
import styled, { css } from 'styled-components'

const v4 = css`
  h2 {
    font-weight: 700;
    color: var(--clr-accent-to-white);
  }
  p {
    margin: var(--base) 0;
  }
`

export const StartGrid = styled.div`
  margin-top: 55px;
  border-top: 1px solid var(--clr-grey-6-to-text);
  color: var(--clr-grey-3-to-text);
`
export const Content = styled(Row)`
  margin-top: 55px;
  min-height: 350px;
  overflow: hidden;
  border-bottom: 1px solid var(--clr-grey-6-to-text);
  padding-bottom: 30px;
  span {
    margin-top: 10px;
    font-size: 5em;
    font-weight: 700;
    color: var(--clr-accent-to-grey-0);
  }
  img {
    height: 325px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
  }
`
export const PanelBody = styled(Col)`
  padding-left: 40px;
  h2 {
    margin-top: 25px;
    color: var(--clr-grey-4-to-white);
 }

p {
    text-decoration: none;
    color: var(--clr-accent);
    font-size: var(--h5);
    cursor: pointer;
}
p:hover {
    text-decoration: underline;
}
${props => props.version === 'v4' && v4}
`



// WEBPACK FOOTER //
// ./src/components/GettingStarted/styles.js